import { render, staticRenderFns } from "./CompraDiretaEmHomologacaoTabela.vue?vue&type=template&id=da098920&scoped=true"
import script from "./CompraDiretaEmHomologacaoTabela.vue?vue&type=script&lang=js"
export * from "./CompraDiretaEmHomologacaoTabela.vue?vue&type=script&lang=js"
import style0 from "./CompraDiretaEmHomologacaoTabela.vue?vue&type=style&index=0&id=da098920&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da098920",
  null
  
)

export default component.exports